import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { UnifiedSurveyStore } from "./unified-survey.store";

// auth.interceptor.ts
export const surveyAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(UnifiedSurveyStore);
  const sessionToken = store.sessionToken();

  // If we have a session token, clone the request and add the Bearer header
  if (sessionToken && !req.url.includes('handshake')) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
  }

  return next(req);
};
